// Dependencias generales
import React from "react";
import { useEffect } from 'react';

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");
var analyticsCommonJS = require("../../js/analyticsCommon.js");

// Función del router
const FilterGroup = (params) => {    

    useEffect(() => {                 
      console.log("Componente grupo de filtros cargado correctamente.")     
    }, [params]);

    function ocultarMensajeValidacion(){
      document.getElementById("divMensajeErrorFiltros").className = document.getElementById("divMensajeErrorFiltros").className.replaceAll("hidden", "")
      document.getElementById("divMensajeErrorFiltros").className += " hidden"    
      
      analyticsCommonJS.actualizarConteoFiltrosSinRefrescar()      

    }

    function seleccionarTodos(idGrupo){
      var objCheckboxesFiltrado = document.getElementById(idGrupo).querySelectorAll("input[type='checkbox']")

      for(var x=0; x < objCheckboxesFiltrado.length; x++){        
        document.getElementById(objCheckboxesFiltrado[x].id).checked = true
      }

      analyticsCommonJS.actualizarConteoFiltrosSinRefrescar()      

    }

    function setearIconoGrupo(){

      var icono = ""

      if (params.groupId === "GeneralData"){ icono = "analytics" }
      else if(params.groupId === "MeteoData"){ icono = "cloud" }
      else if(params.groupId === "InstallationData"){         

        if(localStorage.getItem("activeUserInstallationName") !== null){ //Es un instalador consultando
          icono = dashboardCommonJS.obtenerIconoInstalacion(localStorage.getItem("activeUserInstallationName").split("*")[0])
        }
        else{ // Es un usuario consultando
          icono = dashboardCommonJS.obtenerIconoInstalacion(localStorage.getItem("installationName").split("*")[0])
        }
      }
      else if(params.groupId === "FVData"){ icono = "solar_power" }
      else if(params.groupId === "BatteriesData"){ icono = "battery_std" }
      else if(params.groupId === "GeneratorData"){ icono = "dynamic_form" }
      else if(params.groupId === "CarsData"){ icono = "directions_car" }      
      else if(params.groupId === "SelfConsumptionAndSavingsData"){ icono = "euro" }      

      return icono

    }

    if(params.objGroup.length > 0){
      const listFilterGroup = params.objGroup.map((filter) =>

        <React.Fragment key={filter}>
          <input type="checkbox" id={filter} searchtext={initialConfigCommonJS.obtenerLiteralAtributo(filter)} onClick={() => ocultarMensajeValidacion()} />
          <label id={"labelDatos"+filter} className="icon-wrapper" htmlFor={filter} >            
            <span className="label" >{initialConfigCommonJS.obtenerLiteralAtributo(filter)}</span>
          </label>
        </React.Fragment>
      );    

      return (
        <details id={params.groupId} className="accordion">
          <summary className="title">
            <figure className="avatar size-l"><span className="material-icon">{setearIconoGrupo()}</span></figure>            
            <span >{params.groupName}</span>
            <span id={"spanSeleccionados"+params.groupId} className="link"></span>
          </summary>
          <fieldset className="check multiple gap-02 accordion-content">
            <button id={"botonSeleccionarTodosGrupo"+params.groupId} className="link size-xs" onClick={() => seleccionarTodos(params.groupId)}><span className="material-icon size-s">playlist_add_check</span>Seleccionar todo este grupo</button>
            {listFilterGroup} 
          </fieldset>
        </details>
      )
    }
    
}

export default FilterGroup